import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import { Button, Typography } from '@s4l/ds'
import { Link } from '@s4l/react-facade'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import Image from '../../../Atoms/Image'

import type { Ancillary } from '@s4l/stayforlong/booking/Ancillary'
import { type AncillaryTypes } from '@s4l/stayforlong/booking/AncillaryType'
import styles from './index.module.css'

interface AncillaryCardProps extends ReturnType<Ancillary['toJSON']> {
  onClick?: (data: { type: AncillaryTypes }) => void
}

function noop() {} // eslint-disable-line @typescript-eslint/no-empty-function

export default function AncillaryCard({
  type,
  link,
  titleKey,
  bodyKey,
  ctaKey,
  imageSrc,
  onClick = noop,
}: AncillaryCardProps) {
  const { i18n } = useS4LContext()

  const handleClick = () => onClick({ type })

  if (!titleKey || !bodyKey || !ctaKey || !imageSrc || !link) return null

  return (
    <Link
      href={link}
      className={styles.ancillaryLink}
      data-testid="ancillary-card"
      onClick={handleClick}
      target="_blank"
    >
      <div className={styles.ancillary}>
        <div className={styles.content}>
          <Typography as="p" variant="body" size="xl" bold>
            {i18n.formatMessage({ id: titleKey })}
          </Typography>

          <Image
            src={imageSrc}
            alt={`${i18n.formatMessage({ id: titleKey })} Image`}
            style={{
              borderRadius: 'var(--radius-8)',
            }}
            width={144}
            height={80}
          />

          <Typography as="p" variant="body" size="l">
            {i18n.formatMessage({ id: bodyKey })}
          </Typography>
        </div>

        <div className={styles.actions}>
          <Button variant="filled-rounded" size="large" trailingIcon={<IconArrowRight />}>
            {i18n.formatMessage({ id: ctaKey })}
          </Button>
        </div>
      </div>
    </Link>
  )
}
